import React, { useEffect, useRef } from "react"
import { ContentItem } from "@shared"

/**
 * Used in conjunction with the TechSpecsList to render a given tech item.
 * @param {object} props - react props
 * @param {string} props.title - title of the row (the spec)
 * @param {string} props.content - the html content for the tech spec item
 * @param {string} props.id - id for the contentful item
 * @param {string} props.contentClass - css className for the content wrapper
 * @param {string} props.titleClass - css className for the title item
 * @param {string} props.extraContentWrapper - css className for wrapper around content
 * @param {string} props.extraTitleWrapper - css className for wrapper around title
 */
const TechSpecItem = ({
  title,
  content,
  id,
  extraContentWrapper,
  contentClass,
  extraTitleWrapper,
  titleClass
}) => {
  let internal = "exo.inc"
  const contentRef = useRef(null)
  useEffect(() => {
    const isBrowser = typeof window !== "undefined"
    if (isBrowser) {
      //  GET THE CURRENT URL
      internal = window.location.host.replace("www.", "")
    }
    const convertedInternal = new RegExp(internal, "i")
    const myElement = document.createElement("div")
    myElement.innerHTML = content
    const a = myElement.getElementsByTagName("a")
    for (let i = 0; i < a.length; i++) {
      const href = a[i].host.replace("www.", "") // set the host of each link
      if (!convertedInternal.test(href)) {
        // make sure the href doesn't contain current site's host
        a[i].setAttribute("target", "_blank") // if it doesn't, set attributes
      }
    }
    contentRef.current.innerHTML = myElement.innerHTML
  }, [])

  return (
    <>
      <ContentItem gridArea="blockTwo" extraClass={extraTitleWrapper}>
        <h4 className={titleClass} id={`Spec-Item-${id}`}>
          {title}
        </h4>
      </ContentItem>
      <ContentItem gridArea="blockThree" extraClass={extraContentWrapper}>
        <div className={contentClass} aria-labelledby={`Spec-Item-${id}`} ref={contentRef} />
      </ContentItem>
    </>
  )
}

export default TechSpecItem
